import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { SiteHeader } from '../../components/site-header'
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card'
import { Button } from '../../components/ui/button'
import { SurveyInsightsView } from '../../components/survey/insights/survey-insights-view'
import { supabase } from '../../lib/supabase'
import { Loader2, ArrowLeft } from 'lucide-react'

export default function SurveyInsightsPage() {
  const { code } = useParams<{ code: string }>()
  const navigate = useNavigate()
  const [surveyName, setSurveyName] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const loadSurveyDetails = async () => {
      if (!code) return

      try {
        const { data, error } = await supabase
          .from('survey_codes')
          .select('organization_name')
          .eq('code', code)
          .single()

        if (error) throw error
        setSurveyName(data.organization_name)
      } catch (error) {
        console.error('Error loading survey details:', error)
      } finally {
        setIsLoading(false)
      }
    }

    loadSurveyDetails()
  }, [code])

  if (!code) {
    return <div>Invalid survey code</div>
  }

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <div className="container py-8">
          <div className="space-y-8">
            <div className="flex items-center justify-between">
              <div className="space-y-1">
                <Button
                  variant="ghost"
                  onClick={() => navigate('/survey/manage')}
                  className="mb-4"
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Back to Survey Management
                </Button>
                <h1 className="text-3xl font-bold tracking-tight">
                  {isLoading ? (
                    <Loader2 className="h-8 w-8 animate-spin" />
                  ) : (
                    `${surveyName || 'Survey'} Insights`
                  )}
                </h1>
                <p className="text-lg text-muted-foreground">
                  Comprehensive analysis and recommendations based on survey responses
                </p>
              </div>
            </div>

            <SurveyInsightsView surveyCode={code} />
          </div>
        </div>
      </main>
    </div>
  )
}